import { joinPath } from './joinPath';
export function getItisUrl(path) {
    return joinPath('/jcb', path !== null && path !== void 0 ? path : '');
}
